/* eslint-disable no-magic-numbers */
import { h, Fragment, ComponentChildren } from "preact";

import classname from "../../../foundation/utils/classname";
import PopoverWithHover from "../Popover/PopoverWithHover";
import { PopoverWithHoverProps } from "../Popover/PopoverWithHover/PopoverWithHover";

import styles from "./Tooltip.module.css";

type InheritedPopoverProps = Omit<PopoverWithHoverProps, "contentClass" | "offset" | "arrowClass" | "arrowOptions">;

interface Props extends InheritedPopoverProps {
    title?: ComponentChildren;
    subtitle?: ComponentChildren;
}

function Tooltip({
    class: cssClass,
    textClass = "caption-1",
    title,
    subtitle,
    content,
    children,
    ...popoverProps
}: Props) {
    function renderTooltipContent() {
        const tooltipContent = content ?? (
            <>
                {title && <span class={classname(styles.title, textClass)}>{title}</span>}
                {subtitle && <span class={classname(styles.subtitle, textClass)}>{subtitle}</span>}
            </>
        );

        return (
            <div
                class={classname(styles.tooltipContent, textClass)}>
                {tooltipContent}
            </div>
        );
    }

    return (
        <PopoverWithHover
            {...popoverProps}
            class={classname(styles.tooltip, styles.tooltipClassToIncreaseSpecificity, cssClass)}
            content={renderTooltipContent()}
            contentClass={styles.popoverContent}
            offset={6} // TODO-electron-post-release-yahya: Calculate this based on the arrow size
            arrowClass={styles.arrow}
            arrowOptions={{
                width: 10,
                height: 10
            }}>
            {children}
        </PopoverWithHover>
    );
}

export default Tooltip;
export {
    Props as TooltipProps
};
